module.exports = __webpack_public_path__ + "media/images/og-newsroom-9827a2b4e1736ab6b3c54166855be51f.jpg";